import { SupportedLanguage } from '../config/constants/supportedLanguage.enum';
import { PostalCodeValidation } from '../app/common/fields/postalcode/PostalCodeValidation';
import JPStatesEn from '../i18n/jp-states/states-en.json';
import JPStatesJp from '../i18n/jp-states/states-jp.json';
import JPStatesZh from '../i18n/jp-states/states-zh-cn.json';

const STATE_MAP: Record<string, Partial<Record<SupportedLanguage, string>>> = {};

JPStatesJp.forEach((state, index) => {
    STATE_MAP[state.code] = {
        en: JPStatesEn[index].name,
        ja: state.name,
        'zh-CN': JPStatesZh[index].name,
    };
});

export class TextHelpers {
    private static unicodeSubstring(str: string, end: number) {
        const reg = new RegExp(`^.{0}(.{0,${end}})`, 'u');
        return str.match(reg)?.[1];
    }

    public static trimText(text: string, trimLength: number): string {
        if (text.length > trimLength) {
            return TextHelpers.unicodeSubstring(text, trimLength) + '...';
        }

        return text;
    }

    public static getStateDisplayValue(state: string, locale: SupportedLanguage) {
        const stateInfo = STATE_MAP[state];

        if (stateInfo) {
            return stateInfo[locale] || (stateInfo.en as string);
        } else {
            return state;
        }
    }

    public static getForeignPostValue(value: string) {
        if (value === 'Foreign') {
            return '国外';
        }
        return value;
    }

    public static getCityPostValue(values: any) {
        const { postalCode, city, countryCode } = values;
        if (PostalCodeValidation.isOverSeasPostalCode(postalCode)) {
            return countryCode;
        }

        return city;
    }

    public static templateRender(
        template: string,
        context: Record<string, string | null> | null,
    ): string {
        if (context) {
            return template.replace(/{(.*?)}/g, (_, key) => context[key.trim()] ?? `{${key}}`);
        }
        return template;
    }

    public static replaceLang(url: string, locale: string, replaceType?: string): string {
        const languageMap: Map<string, string> = new Map([
            ['zh-CN', 'zh_CN'],
            ['zh-TW', 'zh_TW'],
            ['ja', 'ja'],
            ['en', 'en'],
            ['th', 'th'],
            ['zh-HK', 'zh_HK'],
            ['id', 'id'],
            ['ko', 'ko'],
            ['vi', 'vi'],
        ]);

        if (replaceType === 'account') {
            languageMap.set('zh-CN', 'zh-cn');
            languageMap.set('zh-TW', 'zh-cn');
        }

        const lang = languageMap.get(locale) ?? 'en';
        return url.replace('{lang}', lang);
    }

    public static replaceMyDataLang(url: string, locale: string): string {
        const languageMap: Map<string, string> = new Map([
            ['zh-CN', 'ch'],
            ['zh-TW', 'ch'],
            ['ja', 'ja'],
            ['en', 'en'],
        ]);

        const lang = languageMap.get(locale) ?? 'en';
        return url.replace('{lang}', lang);
    }

    public static setLastVisitedPathHandle(path: string, prefix?: string) {
        if (path.indexOf('error') !== -1) {
            return '';
        }

        if (prefix && path.indexOf(prefix) !== -1 && path.startsWith(prefix)) {
            return path.replace(prefix, '');
        }

        return path;
    }

    public static returnUrlTextConfigHandle(returnUrlTextConfig: any, locale: string) {
        if (typeof returnUrlTextConfig === 'string') {
            return returnUrlTextConfig;
        }

        if (typeof returnUrlTextConfig === 'object') {
            return returnUrlTextConfig[locale] ?? returnUrlTextConfig['en'];
        }
    }
}
